module.exports = __webpack_public_path__ + "media/honey-icons/icon-star-159717db.svg";